import { useEffect, useState } from 'react';
import { IOpportunitiesLines, IOpportunitiesProjects, OpportunityDashborardHistoricVO } from '../../../../Interfaces/IOpportunitiesPanels';
import './styles.css';
import CollapseLinesHeaderComponent from './CollapseLinesHeader';

interface ICollaspeLinesProps {
    grantsLines?:  OpportunityDashborardHistoricVO,
    projectsByGrant?: IOpportunitiesProjects,
    setLoading: (data: boolean) => void;
}

interface IHistoricGrouped {
    title: string,
    grants: IOpportunitiesLines[]
}

const CollapseLinesComponent = (props: ICollaspeLinesProps) => {
    const [historicGrouped, setHistoricGrouped] = useState<IHistoricGrouped[]>([]);

    function groupingHistoric() {
        props.setLoading(true);

        var historic = props.grantsLines?.favoriteGrantsHistorics.reduce((group: any, grants) => {
            const { groupName } = grants;

            group[groupName] = group[groupName] ?? [];
            group[groupName].push(grants);

            return group;
        }, {});

        var list: IHistoricGrouped[] = [];
    
        var obj = Object.entries(historic!);
        
        obj.map(x =>{
            var group: IHistoricGrouped = { 
                title : x[0],
                grants : x[1] as IOpportunitiesLines[]
            }
            list.push(group);
        });
        

        setHistoricGrouped(list);

        if(list.length == 0){
            props.setLoading(false)
        }
    }
    
    useEffect(() => {
        if (historicGrouped.length > 0) {
            props.setLoading(false)
        }
    }, [historicGrouped]);

    useEffect(() => {
        if (props.grantsLines != null) {
            groupingHistoric()
        }
    }, [props.grantsLines]);

    return (
        <div>
            {historicGrouped.map((lines, index) => {
                return (
                    <div key={index} className='margin-header-collapse'>
                        <CollapseLinesHeaderComponent
                            title={lines.title}
                            lines={lines.grants} />
                    </div>
                )
            })}
        </div>
    )
}

export default CollapseLinesComponent;